import { render, staticRenderFns } from "./importantform.vue?vue&type=template&id=37da829f&scoped=true"
import script from "./importantform.vue?vue&type=script&lang=js"
export * from "./importantform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_cache-loader@4.1.0_webpack@4.47.0_supports-_28b733ef3ef89602fda58894ac543489/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37da829f",
  null
  
)

export default component.exports